export default __webpack_public_path__ + "static/media/burjeel-logo-export.5da54e4e.svg";